import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'


// import 'element-plus/theme-chalk/src/index.scss'
import "element-plus/dist/index.css"
import '@/assets/css/element-plus/index.scss'
import VueI18n from '@/locales'
import '@/permission'
//样式
import 'tinymce/skins/content/default/content.min.css'
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/skins/ui/oxide/content.min.css'

import '@/assets/css/base.scss'
import useDirectives from './directives'

axios.get('/http.json').then((response) => {

  sessionStorage.setItem('http_config_datas', JSON.stringify(response.data))

  const app = createApp(App)
  // 注册全局自定义指令
  useDirectives(app)


  app.use(store)
    .use(ElementPlus, { locale: VueI18n.global.locale === 'en' ? en : zn })
    .use(router)
    .use(VueI18n)
    .mount('#app')


})



